
// ══════════════════════════════════════════════════════════════════
// EN — reemplaza tu export const booking en el archivo de inglés
// ══════════════════════════════════════════════════════════════════
export const booking = {
  createBooking: "Créer une réservation",
  detailsTitle: "Détails de la réservation",
  createdOn: "créée le",
  statusBooked: "Réservée",
  processing: "Traitement...",
  reject: "Refuser",
  cancelled: "Réservation annulée",
  guests: "Clients",
  nights: "Nuits",

  responsibleTitle: "Responsable de la réservation",
  name: "Nom",
  email: "E-mail",
  emailNotProvided: "Aucun e-mail fourni",
  phone: "Téléphone",
  phoneNotProvided: "Aucun téléphone fourni",
  replyWhatsapp: "Répondre sur WhatsApp",
  notes: "Note",
  notesEmpty: "Aucune note",
  notesPlaceholder: "Notes internes de réservation (ex. arrivée tardive, lit bébé, allergies…)",
  notesEdit: "Modifier la note",
  notesSave: "Enregistrer",
  notesCancel: "Annuler",
  notesSaved: "Note mise à jour",
  notesSaveError: "Impossible d'enregistrer la note",

  amountTitle: "Montant de la réservation",

  // Menu buttons & states
  validatingLink: "Validation du lien...",
  sendPaymentLink: "Envoyer le lien de paiement",
  copyPaymentLink: "Copier le lien de paiement",
  sendingPaymentLink: "Envoi du lien de paiement…",
  whatsappSent: "Lien de paiement envoyé via WhatsApp.",
  whatsappSentFallback: "Échec de l'envoi du modèle. WhatsApp ouvert manuellement.",
  freeReservationInfo: "Réservation gratuite - Aucun paiement requis",
  stripeNotConfigured: "Stripe non configuré",
  changePaymentStatus: "Modifier le statut du paiement",

  // Amount status
  amountStatus: "Statut du montant",
  paymentPending: "Paiement en attente",
  paid: "Payé",
  rejected: "Refusé",
  refunded: "Remboursé",
  partial: "Paiement partiel",

  // Totals
  subtotal: "Sous-total :",
  totalDiscounts: "Total des remises :",
  totalTaxes: "Total des taxes :",
  total: "Total :",

  // Payment status modal
  changePaymentStatusHeader: "Modifier le statut du paiement",
  paymentStatusLabel: "Statut du paiement",
  select: "Sélectionner",
  pending: "En attente",
  paidShort: "Payé",
  close: "Fermer",
  saveChanges: "Enregistrer les modifications",

  // Toastr / Messages
  paymentUrlSuccess: "URL de paiement générée avec succès",
  paymentUrlError: "Erreur lors de la génération de l'URL de paiement",

  linkGenerated: "Lien de paiement généré avec succès",
  linkRegenerated: "Lien de paiement mis à jour en raison de changements de prix",
  linkPriceZero: "Impossible de générer un lien de paiement pour les réservations gratuites ($0)",
  linkNoStripe: "L'utilisateur n'a pas configuré Stripe pour recevoir des paiements",
  linkNoProvider: "Aucun fournisseur de paiement configuré (Stripe ou Wompi)",  // ✅ NUEVA
  linkValidationFailed: "Impossible de générer le lien de paiement. Des données requises sont manquantes.",
  linkValidateError: "Erreur lors de la validation du lien de paiement",
  linkValid: "Le lien de paiement est valide",

  copySuccess: "Le lien a été copié avec succès",
  copied: "Copié !",
  copyError: "Une erreur s'est produite lors de la copie du lien",
  error: "Erreur",
  statusUpdatedSuccess: "Statut mis à jour avec succès",
  statusUpdatedError: "Erreur lors de la mise à jour du statut du paiement",  // ✅ NUEVA

  // WhatsApp
  whatsappPayMessage: "Bonjour {name} ! Voici votre lien pour régler votre réservation : {url}",

  checkinsOf: "Check-ins de cette réservation ({done} sur {total})",
  completed: "Terminés",
  pendings: "En attente",
  date: "Date",
  noCheckinsYet: "Les clients de cette réservation n'ont pas encore effectué le check-in",

  alojamiento: "Hébergement",
};

